import { ItemDelegate } from '@leverege/molten/imagine';
export default {
  id: 'bill.locationAddress',
  name: 'bill.locationAddress',
  displayName: 'Location Address',
  valueType: 'string',
  objectType: 'bill',
  placement: {
    group: []
  },
  get: obj => {
    const invoiceImagineDevice = ItemDelegate.getItem(obj.id);
    const locationId = invoiceImagineDevice?.data?.location?.id;
    const locationImagineDevice = ItemDelegate.getItem(locationId);
    const streetAddress = locationImagineDevice?.data?.streetAddress;
    return streetAddress;
  }
};